/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementEditOrderResponse } from './StoreHistoryManagementEditOrderResponse';

export type StoreHistoryManagementEditOrderResponseApiRespoonse = {
    data?: StoreHistoryManagementEditOrderResponse;
    status?: StoreHistoryManagementEditOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreHistoryManagementEditOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

